import { fg } from '@atlassian/jira-feature-gating';

export function isReactCompilerForLabelsFieldEnabled() {
	if (fg('react_compiler_for_labels_field')) {
		return true;
	}
	return false;
}

export function isReactCompilerForBatch1Enabled() {
	if (fg('jiv_react_compiler_batch_1')) {
		return true;
	}
	return false;
}

export function isReactCompilerForIssueAttachmentsEnabled() {
	if (fg('jiv_react_compiler_for_issue_attachments')) {
		return true;
	}
	return false;
}

export function isReactCompilerForBatch2Enabled() {
	if (fg('jiv_react_compiler_batch_2')) {
		return true;
	}
	return false;
}

// Relay Fields Feature Gates
export function isReactCompilerForRelaySimpleFieldsEnabled() {
	if (fg('react_compiler_relay_fields_simple_packages')) {
		return true;
	}
	return false;
}

export function isReactCompilerForRelayFieldsEnabled() {
	if (fg('react_compiler_relay_fields_packages')) {
		return true;
	}
	return false;
}

export function isReactCompilerForRelayComplexFieldsEnabled() {
	if (fg('react_compiler_relay_fields_complex_packages')) {
		return true;
	}
	return false;
}
// End of Relay Fields Feature Gates

// Legacy fields
export function isReactCompilerForLegacySimpleFieldsEnabled() {
	if (fg('react_compiler_legacy_fields_simple_packages')) {
		return true;
	}
	return false;
}

export function isReactCompilerForLegacyFieldsEnabled() {
	if (fg('react_compiler_legacy_fields_packages')) {
		return true;
	}
	return false;
}

export function isReactCompilerForLegacyComplexFieldsEnabled() {
	if (fg('react_compiler_legacy_fields_complex_packages')) {
		return true;
	}
	return false;
}
// End of Legacy fields

// Issue view
export function isReactCompilerForIssueTopComponentsEnabled() {
	if (fg('jiv_react_compiler_for_issue_top_components')) {
		return true;
	}
	return false;
}

export function isReactCompilerForIssueViewSimplePackagesEnabled() {
	if (fg('react_compiler_issue_view_simple_packages')) {
		return true;
	}
	return false;
}

export function isReactCompilerForIssueViewPackagesEnabled() {
	if (fg('react_compiler_issue_view_packages')) {
		return true;
	}
	return false;
}

export function isReactCompilerForIssueViewComplexPackagesEnabled() {
	if (fg('react_compiler_issue_view_complex_packages')) {
		return true;
	}
	return false;
}
// End of Issue view
